import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';

export interface CountDownTime {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  percentage: string;
  danger: boolean;
  circleDasharray: string;
}

@Injectable({
  providedIn: 'root'
})
export class CountDownService {

  constructor() { }

  countDownTime(timeLeftMilli: number, maxTimeHours = 48): Observable<CountDownTime> {
    const dateEnd = new Date(new Date().getTime() + timeLeftMilli);
    const dtMoment = moment(dateEnd);
    const dateInit = dtMoment.add(-maxTimeHours, 'hours').toDate();
    return new Observable(observer => {
      const second = 1000;
      const minute = second * 60;
      const hour = minute * 60;
      const day = hour * 24;

      // tslint:disable-next-line: no-shadowed-variable
      let interval = null;

      const downTime = () => {
        const now = new Date();
        const distance = dateEnd.getTime() - now.getTime();
        if (distance < 0) {
          clearInterval(interval);
          observer.complete();
          return;
        }

        const dtInicialFinal = this.diffInDays(dateInit, dateEnd) as number;
        const dataInicialAtual = this.diffInDays(dateInit, now) as number;
        const pctNumber = 1 - (dataInicialAtual / dtInicialFinal);
        const danger = pctNumber <= 0.25;

        let percentage = (pctNumber * 100).toFixed(2);

        const days = Math.floor(distance / day);
        const hours = Math.floor((distance % day) / hour);
        const minutes = Math.floor((distance % hour) / minute);
        const seconds = Math.floor((distance % minute) / second);


        if (parseInt(percentage, 10) > 100) {
          percentage = '100';
        }

        const circleDasharray = this.getCircleDasharray(percentage)
        observer.next({
          days,
          hours,
          minutes,
          seconds,
          percentage,
          danger,
          circleDasharray
        });
      };
      downTime();
      interval = setInterval(downTime, second);
    });
  }

  private diffInDays(date1: Date, date2: Date) {
    const dif = date2.getTime() - date1.getTime();
    const seconds = 60 * 60 * 24;
    return dif / seconds;
  }

  private getCircleDasharray(percentage): string {
    const FULL_DASH_ARRAY = 314;
    const dashLength = (FULL_DASH_ARRAY * parseInt(percentage)) / 100;

    return `${dashLength} ${FULL_DASH_ARRAY}`;
  }
}
